export { default } from './CardProductBasket';
